import axiosInstance from "../../axiosInstance";

const BASE_URL = "/hrm/signing-requests";

export const getSigningRequests = async (params = {}) => {
  const response = await axiosInstance.get(BASE_URL, { params });
  return response.data;
};

export const getPendingSigningRequests = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/pending`);
  return response.data;
};

export const getActiveSigningAssets = async (requestId) => {
  const response = await axiosInstance.get(`${BASE_URL}/active-assets`, {
    params: requestId ? { request_id: requestId } : undefined,
  });
  return response.data;
};

export const getSigningRequest = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

export const createSigningRequest = async (formData) => {
  const response = await axiosInstance.post(BASE_URL, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const submitSigningRequest = async (id) => {
  const response = await axiosInstance.patch(`${BASE_URL}/${id}/submit`);
  return response.data;
};

export const approveCooSigningRequest = async (id, note = "") => {
  const response = await axiosInstance.post(`${BASE_URL}/${id}/approve-coo`, { note });
  return response.data;
};

export const saveSigningPlacements = async (id, placements) => {
  const response = await axiosInstance.post(`${BASE_URL}/${id}/placements`, { placements });
  return response.data;
};

export const applySigning = async (id) => {
  const response = await axiosInstance.post(`${BASE_URL}/${id}/apply-sign`);
  return response.data;
};

export const rejectSigningRequest = async (id, reason) => {
  const response = await axiosInstance.post(`${BASE_URL}/${id}/reject`, { reason });
  return response.data;
};

export const notifySigningRecipients = async (id, employee_ids) => {
  const response = await axiosInstance.post(`${BASE_URL}/${id}/notify`, { employee_ids });
  return response.data;
};

export const sendSignedDocumentEmail = async (id, payload) => {
  const response = await axiosInstance.post(`${BASE_URL}/${id}/send-email`, payload);
  return response.data;
};

export const deleteSigningRequest = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};

export const fetchSigningPdfBlob = async (id, variant = "original") => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}/pdf`, {
    params: { variant },
    responseType: "arraybuffer",
  });
  return response.data;
};

export const fetchSignatureAssetImageBlob = async (assetId) => {
  // Dùng endpoint HRM signing (perm hrm.signing R) — không qua settings.signature_assets
  // để COO/CEO ký được dù không có quyền Settings.
  const response = await axiosInstance.get(
    `${BASE_URL}/assets/${assetId}/image`,
    { responseType: "arraybuffer" }
  );
  return response.data;
};
